var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95831 3.9585H16.0416V16.0418H3.95831V3.9585Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52871 8.65589C9.52871 8.37193 9.76132 8.26016 10.148 8.26016C10.7038 8.26016 11.4046 8.42933 11.9605 8.72839V7.01256C11.3533 6.77089 10.7552 6.67725 10.151 6.67725C8.66778 6.67725 7.68298 7.45058 7.68298 8.7435C7.68298 10.7584 10.4591 10.4382 10.4591 11.3082C10.4591 11.6435 10.1661 11.7522 9.7583 11.7522C9.15111 11.7522 8.37777 11.5045 7.76455 11.1692V12.9062C8.44423 13.1992 9.12996 13.3231 9.7583 13.3231C11.2778 13.3231 12.323 12.5709 12.323 11.2629C12.3109 9.08787 9.52871 9.47454 9.52871 8.65589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.8fe30327aec30612f6bb4124eb00a412.svg";
export { ForwardRef as ReactComponent };